// removed by extract-text-webpack-plugin
module.exports = {"spinner-indicator":"spinner-indicator","rotate":"rotate"};


//////////////////
// WEBPACK FOOTER
// ./src/common/component/loader/component/spinner-indicator/spinner-indicator.style.sass
// module id = 24hw
// module chunks = 3